import React from "react";
import { NameScammed } from "./NameScammed";

export const UserList = ({ data }) => {
  if (!data || data.length === 0) {
    return <p className="text-gray-500 text-center">No users found.</p>;
  }

  return (
    <ul className="divide-y divide-gray-300">
      {data.map((user) => (
        <li key={user.id} className="py-2 flex justify-between items-center">
          <span className="font-medium text-gray-800"><NameScammed user={user} /></span>
          <span className="text-gray-600">Id: {user.id}</span>
        </li>
      ))}
    </ul>
  );
};

